import { SxProps } from '@mui/material';

export const departmentsMenuSX: SxProps = {
	'& .MuiPaper-root': {
		maxHeight: '80vh',
		marginTop: '1px',
	},
	'& .MuiList-root': {
		padding: '0px',
	},
};
